import { Phone } from "lucide-react";

const WHATSAPP_NUMBER = "5521973548387";

interface WhatsAppButtonProps {
  message?: string;
  className?: string;
}

const WhatsAppFloatingButton = ({ message = "Olá! Gostaria de mais informações sobre os imóveis disponíveis." }: WhatsAppButtonProps) => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Fale conosco pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-xl transition-transform hover:scale-110"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <Phone className="h-6 w-6 text-card" fill="currentColor" />
    </a>
  );
};

export default WhatsAppFloatingButton;
export { WHATSAPP_NUMBER };
